import { PropertyProxy, ConfigProxy } from '../_helpers/util'

const DEFAULT_PLATFORM_CONFIG = {
  title: 'Turn Invoices Into Cash',
  steps: ['Upload Invoices', 'Get Paid'],
  quickbooks_enabled: true,
  sage_one_enabled: false,
  xero_enabled: false,
  help_title: "Need help? We're on standby.",
  help_number: '415-358-1618',
  account_software_title: 'First, choose your accounting software',
}

export const APConfig = ConfigProxy(
  {
    sallyportcf: PropertyProxy(
      {
        title: 'Together We Grow',
        steps: ['Complete Form', 'Upload AR', 'Get Quote'],
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    newcenturyfinancial: PropertyProxy(
      {
        steps: ['Complete Application', 'Upload Invoices', 'Get Funded'],
        quickbooks_enabled: false,
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    sevenoaks: PropertyProxy(
      {
        title: 'Submit Your Application',
        steps: [],
        help_title: 'Quick and Easy 24 Hour or less Approval',
        help_number: '800-511-4588',
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    scfactoringsolution: PropertyProxy(
      {
        title: 'Turn invoices into cash.',
        steps: [
          'Upload Invoice',
          'After the invoices are verified, approved by insurance company and loaded into the system, we are ready to fund immediately',
          'We continue funding (revolving) up to the limit of your approved facility, granting you fresh cash flow for your working capital',
        ],
        help_title: "Need help? We're on standby.",
        help_number: '(754) 301-8813',
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    twelvefive: PropertyProxy(
      {
        steps: [],
        title: 'Cultivating you passion through finance.',
        help_title: 'We are here to help!',
        help_number: '630-270-3072',
        account_software_title:
          'To make your life easier, please connect the following accounting software, if you have them.\nThis will save you time on gathering documents that we can pull automatically.\n\nPlease note, this will only pull documentation/information from your accounting software and will not\ngive us the ability to change anything, nor do we get access to your username or password.\n',
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    acsfactors: PropertyProxy(
      {
        title: 'Factoring Invoices >> Providing Solutions',
        steps: ['Apply', 'Submit Invoices', `Check your Bank Account - You've got Funds`],
        help_title: `Need help? We're on standby.`,
        help_number: '(310) 951-0596',
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    capitalnow: PropertyProxy(
      {
        title: 'Turn invoices into cash.',
        steps: ['Complete Application', 'Upload Invoices', 'Get Funded'],
        help_number: ' 🇨🇦 403-617-2075    🇺🇸 512-858-8806',
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    ccbg: PropertyProxy(
      {
        title: 'Turn invoices into cash.',
        steps: [],
        help_title: `Need help? Call Capital City Bank Now.`,
        help_number: '850-402-7537',
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    hedayacapital: PropertyProxy(
      {
        title: '',
        steps: ['Fill out an application', 'Upload Information', 'Get Funded'],
        help_title: `Supporting your growth!`,
        help_number: '(212)-233-0044',
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    republicbc: PropertyProxy(
      {
        title: 'Working capital for your business.',
        steps: [],
        help_title: `Need help? We're available.`,
        help_number: '866-722-4987',
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    newbridgeglobal: PropertyProxy(
      {
        title: 'We offer worldwide financing solutions to our clients.',
        steps: [],
        help_title: `Need help? We're on standby.`,
        help_number: '646-595-1170',
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    axosbank: PropertyProxy(
      {
        title: 'Transform Your Invoices into Cash!',
        steps: ['Complete Form', 'Get Approved', 'Get Paid'],
        help_title: `Need help? We're just a call away!`,
        help_number: '(877) 247-7990',
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    portercapital: PropertyProxy(
      {
        quickbooks_enabled: false,
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    marcocapital: PropertyProxy(
      {
        title: 'Welcome to Marco!',
        steps: ['Please answer the following questions', 'Upload your documents', `You'll be hearing from us shortly!`],
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    marcofi: PropertyProxy(
      {
        title: 'Welcome to Marco!',
        steps: [
          'Fill out a brief web application.',
          'Get a funding decision in 5-10 business days.',
          'Tech-enabled workflow built to support growth.',
          'Visibility from invoice to payments',
        ],
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    ctrlpay: PropertyProxy(
      {
        help_title: `Have questions for our friendly experts?`,
        title: 'Your Cashflow Solution',
        steps: [
          'Quick ~ in as little as 24 hours',
          'Cheap ~ starting at 3.5%',
          `Easy ~ upload invoices, wait for approval, get paid`,
        ],
        help_number: '1.800.375.5056',
        chat_url: 'https://www.ctrlpayintl.com',
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    breakoutfinance: PropertyProxy(
      {
        help_number: '888-318-3534',
        chat_url: 'mail:operations@breakoutfinance.com',
      },
      DEFAULT_PLATFORM_CONFIG
    ),
    fastarfunding: PropertyProxy(
      {
        help_number: '888.833.2286',
        chat_url: 'mail:apply@republicbc.com',
      },
      DEFAULT_PLATFORM_CONFIG
    ),
  },
  DEFAULT_PLATFORM_CONFIG
)
